<template>
  <v-dialog
    :fullscreen="$vuetify.breakpoint.smAndDown"
    v-model="dialog"
    @keydown.esc="cancel"
    scrollable
    :max-width="$vuetify.breakpoint.smAndDown ? 'none' : '600px'"
    content-class="fullscreen-dialog"
    persistent
  >
    <v-card class="dialog-card order-history-dialog">
      <v-toolbar color="primary" dense class="header primaryText--text">
        <v-row>
          <v-col cols="2" align-self="end">
            <v-btn text @click="close">{{ $t("close") }}</v-btn>
          </v-col>

          <v-col cols="8" class="d-flex justify-center align-center">
            <div>
              <v-toolbar-title
                class="header-title1"
                v-if="$store.state.store != null && $store.state.store.info != null"
                >{{ $store.getters.storeName }}</v-toolbar-title
              >
              <v-toolbar-title class="header-title2">{{ $t("order_history") }}</v-toolbar-title>
            </div>
          </v-col>

          <v-col cols="2" align-self="end" style="text-align:right"> </v-col>
        </v-row>
      </v-toolbar>

      <v-card-text>
        <v-list class="order-list">
          <v-list-item v-for="(ele, index) in $store.state.orderHistory" :key="index">
            <v-list-item-content>
              <div class="order-box">
                <v-row class="order-header">
                  <v-col> # {{ ele.referenceID }} </v-col>
                  <v-col style="text-align: right;">
                    {{ toLocaleString(ele.time) }}
                  </v-col>
                </v-row>

                <v-row v-if="ele.feed.orderType == 'dinein'" class="order-type">
                  <v-col>
                    <div v-if="ele.feed.tableName != ''">{{ $t("table_name") }} : {{ ele.feed.tableName }}</div>
                    <div v-else>
                      {{ $t("dinein") }}
                    </div>
                  </v-col>
                </v-row>
                <v-row v-if="ele.feed.orderType == 'delivery'" class="order-type">
                  <v-col>{{ $t("delivery") }}</v-col>
                  <v-col v-if="ele.feed.deliveryTime != null" style="text-align: right;">
                    {{ toLocaleString(ele.feed.deliveryTime) }}
                  </v-col>
                  <v-col
                    v-else-if="ele.feed.pickupTime != null && (ele.feed.orderNow == null || !ele.feed.orderNow)"
                    style="text-align: right;"
                  >
                    {{ toLocaleString(ele.feed.pickupTime) }}
                  </v-col>
                </v-row>
                <v-row v-if="ele.feed.orderType == 'takeout'" class="order-type">
                  <v-col>{{ $t("takeout") }}</v-col>
                  <v-col
                    v-if="ele.feed.pickupTime != null && (ele.feed.orderNow == null || !ele.feed.orderNow)"
                    style="text-align: right;"
                  >
                    {{ toLocaleString(ele.feed.pickupTime) }}
                  </v-col>
                </v-row>

                <div
                  v-if="ele.feed.address !== undefined && ele.feed.address != null && ele.feed.address != ''"
                  class="order-address"
                >
                  <v-row
                    v-if="
                      ele.feed.address.name !== undefined &&
                        ele.feed.address.name != null &&
                        ele.feed.address.name != ''
                    "
                    class="content"
                  >
                    {{ ele.feed.address.name }}
                  </v-row>
                  <v-row
                    v-if="
                      ele.feed.address.street !== undefined &&
                        ele.feed.address.street != null &&
                        ele.feed.address.street != ''
                    "
                    class="content"
                  >
                    <v-col>{{ ele.feed.address.street }}</v-col>
                  </v-row>
                  <v-row
                    v-if="
                      ele.feed.address.city !== undefined &&
                        ele.feed.address.city != null &&
                        ele.feed.address.city != ''
                    "
                    class="content"
                  >
                    <v-col>{{ ele.feed.address.city }}</v-col>
                  </v-row>
                  <v-row
                    v-if="
                      ele.feed.address.postal !== undefined &&
                        ele.feed.address.postal != null &&
                        ele.feed.address.postal != ''
                    "
                    class="content"
                  >
                    <v-col>{{ ele.feed.address.postal }}</v-col>
                  </v-row>
                  <v-row
                    v-if="
                      ele.feed.address.province !== undefined &&
                        ele.feed.address.province != null &&
                        ele.feed.address.province != ''
                    "
                    class="content"
                  >
                    <v-col>{{ ele.feed.address.province }}</v-col>
                  </v-row>
                  <v-row
                    v-if="
                      ele.feed.address.phone1 !== undefined &&
                        ele.feed.address.phone1 != null &&
                        ele.feed.address.phone1 != ''
                    "
                    class="content"
                  >
                    <v-col>{{ ele.feed.address.phone1 }}</v-col>
                  </v-row>
                  <v-row
                    v-if="
                      ele.feed.address.phone2 !== undefined &&
                        ele.feed.address.phone2 != null &&
                        ele.feed.address.phone2 != ''
                    "
                    class="content"
                  >
                    <v-col>{{ ele.feed.address.phone2 }}</v-col>
                  </v-row>
                  <v-row
                    v-if="
                      ele.feed.address.remark !== undefined &&
                        ele.feed.address.remark != null &&
                        ele.feed.address.remark != ''
                    "
                    class="content"
                  >
                    <v-col>{{ ele.feed.address.remark }}</v-col>
                  </v-row>
                </div>

                <div v-for="(oi, oiIndex) in ele.feed.items" :key="oiIndex" class="order-content">
                  <v-row>
                    <v-col cols="1">
                      {{ oi.qty }}
                    </v-col>
                    <v-col text-wrap cols="8">
                      <div class="order-item-descr" v-if="$store.state.descrIndex == 0">{{ oi.ord_descr }}</div>
                      <div class="order-item-descr" v-if="$store.state.descrIndex == 1">{{ oi.ord_descr1 }}</div>
                      <div class="order-item-descr" v-if="$store.state.descrIndex == 2">{{ oi.ord_descr2 }}</div>
                    </v-col>
                    <v-col cols="3" class="order-item-price">
                      {{ getItemTotal(oi) | currency }}
                    </v-col>
                  </v-row>

                  <v-row v-if="oi.scalable">
                    <v-col cols="1"> </v-col>
                    <v-col class="item-scale"> {{ oi.weight }} {{ oi.weightUnit }} @ {{ oi.price | currency }} </v-col>
                  </v-row>

                  <v-row v-if="getItemDiscountValue(oi) > 0">
                    <v-col cols="1"> </v-col>
                    <v-col text-wrap cols="8"
                      ><span v-if="oi.redeemedPoints > 0">{{ $t("redeem") }} {{ oi.redeemedPoints }} pts</span>
                      <span v-else-if="oi.discountRate > 0">{{ oi.discountRate }}% {{ $t("discount") }}</span>
                      <span v-else>{{ $t("discount") }}</span>
                    </v-col>
                    <v-col cols="3" class="order-item-price">
                      {{ -getItemDiscountValue(oi) | currency }}
                    </v-col>
                  </v-row>

                  <v-row v-if="oi.comboItem != null">
                    <v-col cols="1">{{ oi.comboItem.qty }} </v-col>
                    <v-col cols="8" text-wrap>
                      <div class="order-item-descr" v-if="$store.state.descrIndex == 0">
                        {{ oi.comboItem.ord_descr }}
                      </div>
                      <div class="order-item-descr" v-if="$store.state.descrIndex == 1">
                        {{ oi.comboItem.ord_descr1 }}
                      </div>
                      <div class="order-item-descr" v-if="$store.state.descrIndex == 2">
                        {{ oi.comboItem.ord_descr2 }}
                      </div>
                    </v-col>
                    <v-col cols="3" class="order-item-price">
                      <div v-if="oi.comboItem.ord_subtotal != null">
                        {{ oi.comboItem.ord_subtotal | currency }}
                      </div>
                    </v-col>
                  </v-row>

                  <div v-if="oi.bundleItems !== undefined && oi.bundleItems.length > 0">
                    <v-row v-for="(bi, biIndex) in oi.bundleItems" :key="biIndex">
                      <v-col cols="1"> </v-col>
                      <v-col cols="8" text-wrap>
                        <div class="order-item-descr" v-if="$store.state.descrIndex == 0">
                          {{ bi.ord_descr }}
                        </div>
                        <div class="order-item-descr" v-if="$store.state.descrIndex == 1">
                          {{ bi.ord_descr1 }}
                        </div>
                        <div class="order-item-descr" v-if="$store.state.descrIndex == 2">
                          {{ bi.ord_descr2 }}
                        </div>
                      </v-col>
                      <v-col cols="3"> </v-col>
                    </v-row>
                  </div>

                  <v-row v-if="oi.redeemItem">
                    <v-col cols="1"></v-col>
                    <v-col class="order-item-redeem">
                      <span class="t-title">{{ $t("redeem") }} : </span>
                      <span class="t-value">{{ oi.redeemPoints }} pts</span></v-col
                    >
                  </v-row>
                </div>

                <v-row class="order-subtotal">
                  <v-col cols="9" style="text-align: right;">
                    {{ $t("subtotal") }}
                  </v-col>
                  <v-col cols="3" style="text-align: right;">
                    {{ ele.feed.subtotal | currency }}
                  </v-col>
                </v-row>
                <v-row v-if="ele.feed.discountValue > 0" class="order-discount">
                  <v-col cols="9" style="text-align: right;">
                    <span v-if="ele.feed.discountRate > 0">{{ ele.feed.discountRate }}% </span>{{ $t("discount") }}
                  </v-col>
                  <v-col cols="3" style="text-align: right;">
                    {{ -ele.feed.discountValue | currency }}
                  </v-col>
                </v-row>
                <v-row v-if="ele.feed.deliveryValue > 0" class="order-delivery">
                  <v-col cols="9" style="text-align: right;">
                    {{ $t("delivery_charge") }}
                  </v-col>
                  <v-col cols="3" style="text-align: right;">
                    {{ ele.feed.deliveryValue | currency }}
                  </v-col>
                </v-row>
                <v-row v-if="ele.feed.serviceValue > 0" class="order-service">
                  <v-col cols="9" style="text-align: right;">
                    <span v-if="ele.feed.serviceRate > 0">{{ ele.feed.serviceRate }}% </span>{{ $t("service_charge") }}
                  </v-col>
                  <v-col cols="3" style="text-align: right;">
                    {{ ele.feed.serviceValue | currency }}
                  </v-col>
                </v-row>
                <v-row class="order-tax">
                  <v-col cols="9" style="text-align: right;">
                    {{ $t("tax") }}
                  </v-col>
                  <v-col cols="3" style="text-align: right;">
                    {{ ele.feed.tax | currency }}
                  </v-col>
                </v-row>
                <v-row class="order-total">
                  <v-col cols="9" style="text-align: right;">
                    {{ $t("total") }}
                  </v-col>
                  <v-col cols="3" style="text-align: right;">
                    {{ ele.feed.total | currency }}
                  </v-col>
                </v-row>
                <v-row v-if="ele.feed.tips > 0" class="order-tips">
                  <v-col cols="9" style="text-align: right;">
                    {{ $t("tips") }}
                  </v-col>
                  <v-col cols="3" style="text-align: right;">
                    {{ ele.feed.tips | currency }}
                  </v-col>
                </v-row>

                <div v-if="ele.feed.payAmount > 0">
                  <v-row class="order-paid">
                    <v-col cols="9" style="text-align: right;">
                      <span v-if="ele.feed.paid[0].data !== undefined && ele.feed.paid[0].data.type == 'giftcard'"
                        >{{ ele.feed.paid[0].data.cardCode | secure }} {{ $t("giftcard") }}
                      </span>
                      {{ $t("paid") }}
                    </v-col>
                    <v-col cols="3" style="text-align: right;">
                      {{ ele.feed.payAmount | currency }}
                    </v-col>
                  </v-row>

                  <div v-if="ele.feed.paid[0].data != null" class="pt-2">
                    <div
                      v-if="ele.feed.paid[0].data.merchant !== undefined && ele.feed.paid[0].data.orderId !== undefined"
                    >
                      <div class="order-paid-data-title">PAYMENT ORDER ID :</div>
                      <div class="order-paid-data-value">{{ ele.feed.paid[0].data.orderId }}</div>
                    </div>

                    <div v-else-if="ele.feed.paid[0].data.data != null">
                      <!--                       <div v-if="ele.feed.paid[0].data.data.CARDTYPE !== undefined">
                        <span class="order-paid-data-title">CARD TYPE : </span
                        ><span class="order-paid-data-value">{{ ele.feed.paid[0].data.data.CARDTYPE }}</span>
                      </div>
                      <div v-if="ele.feed.paid[0].data.data.CARDDIGITS !== undefined">
                        <span class="order-paid-data-title">CARD NO. : </span
                        ><span class="order-paid-data-value">{{ ele.feed.paid[0].data.data.CARDDIGITS }}</span>
                      </div> -->
                      <div v-if="ele.feed.paid[0].data.data.ORDER_ID !== undefined">
                        <div class="order-paid-data-title">PAYMENT ORDER ID :</div>
                        <div class="order-paid-data-value">{{ ele.feed.paid[0].data.data.ORDER_ID }}</div>
                      </div>
                    </div>
                  </div>
                </div>

                <div v-if="ele.feed.orderMemo != '' || ele.feed.billMemo != ''" class="order-memo">
                  <v-row class="header">
                    <v-col>{{ $t("memo") }}</v-col>
                  </v-row>
                  <v-row class="content">
                    <v-col>{{ ele.feed.orderMemo != "" ? ele.feed.orderMemo : ele.feed.billMemo }}</v-col>
                  </v-row>
                </div>

                <div v-if="ele.feed.faceDrive != null && ele.feed.faceDrive.status != null">
                  <v-row>
                    <v-col class="order-delivery-status">
                      <div class="--title d-flex align-center">
                        DELIVERY STATUS :
                        <v-btn class="ml-1" x-small @click="refreshFaceDriveStatus(ele.feed.faceDrive)">refresh</v-btn>
                      </div>
                      <!-- <div class="--status">{{ ele.feed.faceDrive.status }}</div> -->
                      <div class="--status">{{ $t("faceDrive.status." + ele.feed.faceDrive.status) }}</div>
                    </v-col>
                  </v-row>
                </div>
              </div>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>

      <v-card-actions>
        <v-btn v-if="clearButtonVisible" block tile color="warning" class="warningText--text" @click="clearClicked">{{
          $t("clear_history")
        }}</v-btn>
      </v-card-actions>
    </v-card>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({
    dialog: false,
    resolve: null,
    reject: null,

    refreshing: false,
  }),

  created() {},

  computed: {
    clearButtonVisible() {
      return !this.$store.getters.orderHistoryOnCloud;
    },
  },

  methods: {
    async open() {
      this.dialog = true;

      this.refreshing = true;
      await this.loadOrderHistory();
      let faceDriveOrders = this.$store.state.orderHistory.filter(
        ele =>
          ele.feed.orderType == this.$store.state.OT_DELIVERY &&
          ele.feed.faceDrive != null &&
          ele.feed.faceDrive.order_id != null
      );

      let now = new Date();
      faceDriveOrders.forEach(ele => {
        //let orderID = ele.feed.faceDrive.order_id;
        let deliveryTime = this.toDate(ele.feed.deliveryTimeTz);

        // only get status before one day after of delivery time
        if (now.getTime() - deliveryTime.getTime() <= 86400000) {
          this.rest_faceDriveQueryOrder(ele.feed.faceDrive).then(resp => {
            if (resp.result == "ok") {
              let fdData;
              if (Array.isArray(resp.data) && resp.data.length > 0) fdData = resp.data[0];
              else fdData = resp.data;

              this.$set(ele.feed.faceDrive, "status", fdData.openapi_order_status);
            }
          });
        }
      });
      this.refreshing = false;

      return new Promise((resolve, reject) => {
        this.resolve = resolve;
        this.reject = reject;
      });
    },

    close() {
      this.resolve(true);
      this.dialog = false;
    },

    getItemTotal(oi) {
      return ((oi.scalable ? oi.price * oi.weight : oi.price) + oi.optionValue + oi.bAdj) * oi.qty;
    },

    getItemDiscountValue(oi) {
      return oi.discountValue;
    },

    refreshFaceDriveStatus(faceDrive) {
      //let orderID = faceDrive.order_id;
      this.rest_faceDriveQueryOrder(faceDrive).then(resp => {
        if (resp.result == "ok") {
          let fdData;
          if (Array.isArray(resp.data) && resp.data.length > 0) fdData = resp.data[0];
          else fdData = resp.data;

          this.$set(faceDrive, "status", fdData.openapi_order_status);
        }
      });
    },

    clearClicked() {
      this.$root
        .confirmDialog(this.$t("confirm_clearhistory_title"), "", this.$t("confirm_clearhistory_question"))
        .then(resp => {
          if (resp) {
            this.clearOrderHistory();
          }
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/order-history-dialog.scss";
.v-card__text {
  padding: 0px !important;
}
.v-card__actions {
  padding: 0px;
}

.item-scale {
  font-size: 0.9em;
  padding: 0px 4px;
  padding-bottom: 4px;
  white-space: pre-line !important;
  overflow: auto;
}
</style>
